class Node {
  constructor(constructor, edges, chooser) {
    this.constructor = constructor;
    this.edges = edges;
    this.chooser = chooser;
    this.cachedCount = null;
  }

  cards(props) {
    const nextNode = this.edges[this.chooser(props)];
    if (this.constructor) {
      return this.constructor.completed(props) && nextNode
        ? [this].concat(nextNode.cards(props))
        : [this];
    }

    return nextNode.cards(props);
  }

  count() {
    if (this.cachedCount == null) {
      this.computeCount();
    }
    return this.cachedCount;
  }

  computeCount() {
    this.cachedCount =
      (this.constructor ? 1 : 0) +
      Math.max.apply(
        null,
        this.edges.map((nextNode) => nextNode.count())
      );
  }

  collectLeaves() {
    return this.edges.length === 0
      ? [this]
      : this.edges.reduce((l, r) => l.concat(r.collectLeaves()), []);
  }
}

export const Card = (constructor, rest) => new Node(constructor, rest ? [rest] : [], () => 0);

export const Branch = (branches, decide, rest) => {
  const edgeMapping = {};
  const edges = [];

  Object.keys(branches).forEach((key) => {
    edgeMapping[key] = edges.length + 1;
    edges.push(branches[key]);
  });

  const indexChooser = (props) => edgeMapping[decide(props)] || 0;

  const branchNode = new Node(null, edges, indexChooser);

  // Use a hidden empty node for the rest node if not provided
  rest = rest || new Node(null, [], () => 0);
  // link descendant leaves of this branch node to the 'rest'
  // argument, which is a continuation of the graph after branching
  branchNode.collectLeaves().forEach((leaf) => {
    leaf.edges = [rest];
  });
  // Cache the newLeaves to speed up leaf finding for higher level branches.
  const newLeaves = rest.collectLeaves();
  branchNode.collectLeaves = () => newLeaves;
  // Push the rest node onto the front so that it will be the default if
  // no other branch matches (index 0)
  edges.unshift(rest);

  return branchNode;
};

export const End = () => {
  const constructor = () => null;
  constructor.id = 'End';

  const endNode = {
    constructor,
    cards: () => [endNode],
    count: () => 0,
    collectLeaves: () => []
  };
  return endNode;
};

export const percentComplete = (deck, props) => {
  const visibleCards = deck.cards(props);
  const numCompletedCards = visibleCards.length - 1;
  const numRemaining = visibleCards[numCompletedCards].count();
  return 100 * (numCompletedCards / (numCompletedCards + numRemaining));
};



// WEBPACK FOOTER //
// ./src/components/deck/card-graph.js